/**
 * @generated SignedSource<<60abe166d041361d61d13ba6d8dec3c3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksTopicWidgetLazyLoadQuery$variables = {
  isShowChinaScienceDiscoveryWidget: boolean;
  isShowHundredTopTablesDiscoveryWidget: boolean;
  isShowOpenQuestionsSeriesDiscoveryWidget: boolean;
  isShowPostMagazineDiscoveryWidget: boolean;
  scmpPlusPaywallTypeIds?: ReadonlyArray<string> | null | undefined;
};
export type hooksTopicWidgetLazyLoadQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"chinaScienceDiscoveryWidgetQuery" | "discoveryWidgetPostMagazineQueueQuery" | "hundredTopTablesDiscoveryWidgetQuery" | "openQuestionsSeriesDiscoveryWidgetQuery">;
};
export type hooksTopicWidgetLazyLoadQuery = {
  response: hooksTopicWidgetLazyLoadQuery$data;
  variables: hooksTopicWidgetLazyLoadQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isShowChinaScienceDiscoveryWidget"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isShowHundredTopTablesDiscoveryWidget"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isShowOpenQuestionsSeriesDiscoveryWidget"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isShowPostMagazineDiscoveryWidget"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "scmpPlusPaywallTypeIds"
  }
],
v1 = {
  "kind": "Literal",
  "name": "first",
  "value": 6
},
v2 = [
  (v1/*: any*/)
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlAlias",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v9 = [
  (v8/*: any*/)
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "Sponsor",
  "kind": "LinkedField",
  "name": "sponsor",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "images",
      "plural": true,
      "selections": (v9/*: any*/),
      "storageKey": null
    },
    (v10/*: any*/)
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "Topic",
  "kind": "LinkedField",
  "name": "topics",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    (v11/*: any*/),
    (v10/*: any*/)
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headline",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v15 = {
  "alias": "size540x360",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "540x360"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v9/*: any*/),
  "storageKey": "style(filter:{\"style\":\"540x360\"})"
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": [
    (v8/*: any*/),
    (v14/*: any*/),
    (v7/*: any*/),
    {
      "alias": "size1200x800",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "style": "1200x800"
          }
        }
      ],
      "concreteType": "ImageStyle",
      "kind": "LinkedField",
      "name": "style",
      "plural": false,
      "selections": (v9/*: any*/),
      "storageKey": "style(filter:{\"style\":\"1200x800\"})"
    },
    (v15/*: any*/)
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "socialHeadline",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flag",
  "storageKey": null
},
v19 = [
  (v6/*: any*/)
],
v20 = {
  "kind": "InlineFragment",
  "selections": (v19/*: any*/),
  "type": "VideoSection",
  "abstractKey": null
},
v21 = {
  "kind": "InlineFragment",
  "selections": [
    (v10/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v3/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": (v19/*: any*/),
          "type": "Section",
          "abstractKey": null
        },
        (v20/*: any*/),
        (v21/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v24 = [
  (v23/*: any*/)
],
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "summary",
  "plural": false,
  "selections": (v24/*: any*/),
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "readingTime",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commentCount",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flattenTypeIds",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "LiveArticle",
  "kind": "LinkedField",
  "name": "liveArticle",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    (v10/*: any*/)
  ],
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sponsorType",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "description",
  "plural": false,
  "selections": (v24/*: any*/),
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "Author",
  "kind": "LinkedField",
  "name": "authors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "types",
      "storageKey": null
    },
    (v10/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityUuid",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "UrlRedirect",
  "kind": "LinkedField",
  "name": "urlRedirect",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "toUrl",
      "storageKey": null
    },
    (v10/*: any*/)
  ],
  "storageKey": null
},
v35 = [
  (v4/*: any*/),
  (v10/*: any*/)
],
v36 = {
  "alias": null,
  "args": null,
  "concreteType": "Application",
  "kind": "LinkedField",
  "name": "application",
  "plural": false,
  "selections": (v35/*: any*/),
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentSection",
  "storageKey": null
},
v38 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "fullSectionPath",
      "plural": true,
      "selections": (v35/*: any*/),
      "storageKey": null
    },
    (v37/*: any*/)
  ],
  "type": "Section",
  "abstractKey": null
},
v39 = [
  (v4/*: any*/)
],
v40 = {
  "kind": "InlineFragment",
  "selections": (v39/*: any*/),
  "type": "Section",
  "abstractKey": null
},
v41 = {
  "kind": "InlineFragment",
  "selections": (v39/*: any*/),
  "type": "VideoSection",
  "abstractKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v40/*: any*/),
        (v41/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "PaywallType",
  "kind": "LinkedField",
  "name": "paywallTypes",
  "plural": true,
  "selections": [
    (v33/*: any*/),
    (v10/*: any*/)
  ],
  "storageKey": null
},
v44 = {
  "kind": "InlineFragment",
  "selections": [
    (v43/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v45 = {
  "kind": "InlineFragment",
  "selections": [
    (v42/*: any*/),
    (v44/*: any*/)
  ],
  "type": "Content",
  "abstractKey": "__isContent"
},
v46 = {
  "kind": "InlineFragment",
  "selections": [
    (v33/*: any*/),
    (v34/*: any*/),
    (v36/*: any*/),
    (v38/*: any*/),
    (v45/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v47 = {
  "kind": "InlineFragment",
  "selections": [
    (v42/*: any*/)
  ],
  "type": "Content",
  "abstractKey": "__isContent"
},
v48 = {
  "kind": "InlineFragment",
  "selections": [
    (v27/*: any*/),
    (v28/*: any*/),
    (v29/*: any*/),
    (v30/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ArticleTypeSegment",
      "kind": "LinkedField",
      "name": "types",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ArticleType",
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": [
            (v6/*: any*/),
            (v4/*: any*/),
            (v31/*: any*/),
            (v10/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v32/*: any*/),
    (v46/*: any*/),
    (v47/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "duration",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v41/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v51 = {
  "kind": "InlineFragment",
  "selections": [
    (v49/*: any*/),
    (v50/*: any*/)
  ],
  "type": "Video",
  "abstractKey": null
},
v52 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v53 = {
  "kind": "InlineFragment",
  "selections": [
    (v28/*: any*/),
    (v29/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v54 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SectionSegmentV2",
      "kind": "LinkedField",
      "name": "sectionsV2",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": [
            (v3/*: any*/),
            (v40/*: any*/),
            (v21/*: any*/),
            (v41/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v44/*: any*/)
  ],
  "type": "Content",
  "abstractKey": "__isContent"
},
v55 = {
  "kind": "InlineFragment",
  "selections": [
    (v3/*: any*/),
    (v4/*: any*/),
    (v33/*: any*/),
    (v5/*: any*/),
    (v34/*: any*/),
    (v36/*: any*/),
    (v38/*: any*/),
    (v53/*: any*/),
    (v54/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v56 = [
  (v10/*: any*/),
  (v55/*: any*/)
],
v57 = {
  "alias": null,
  "args": null,
  "concreteType": "Newsletter",
  "kind": "LinkedField",
  "name": "relatedNewsletters",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alternativeName",
      "storageKey": null
    },
    (v31/*: any*/),
    (v25/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "homepageDescription",
      "plural": false,
      "selections": (v24/*: any*/),
      "storageKey": null
    },
    (v10/*: any*/)
  ],
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdDate",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedDate",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedDate",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "json",
  "storageKey": null
},
v62 = [
  (v61/*: any*/)
],
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "seriesShortLabel",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "multimediaEmbed",
  "plural": false,
  "selections": (v62/*: any*/),
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "concreteType": "ArticleTypeSegment",
  "kind": "LinkedField",
  "name": "types",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ArticleType",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v4/*: any*/),
        (v10/*: any*/),
        (v6/*: any*/),
        (v31/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasVideoContent",
  "storageKey": null
},
v67 = {
  "kind": "InlineFragment",
  "selections": [
    (v4/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v5/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Topic",
          "kind": "LinkedField",
          "name": "topics",
          "plural": true,
          "selections": [
            (v4/*: any*/),
            (v11/*: any*/),
            (v10/*: any*/),
            (v57/*: any*/),
            (v5/*: any*/),
            (v6/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "shortName",
              "storageKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v3/*: any*/),
                (v33/*: any*/),
                (v34/*: any*/),
                (v36/*: any*/),
                (v38/*: any*/),
                (v53/*: any*/),
                (v54/*: any*/)
              ],
              "type": "BaseWithApplicationAndUrlAlias",
              "abstractKey": "__isBaseWithApplicationAndUrlAlias"
            }
          ],
          "storageKey": null
        },
        (v58/*: any*/),
        (v59/*: any*/),
        (v60/*: any*/),
        (v26/*: any*/),
        (v13/*: any*/),
        (v16/*: any*/),
        (v17/*: any*/),
        (v18/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "SectionSegmentV2",
          "kind": "LinkedField",
          "name": "sectionsV2",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "value",
              "plural": true,
              "selections": [
                (v3/*: any*/),
                {
                  "kind": "TypeDiscriminator",
                  "abstractKey": "__isSectionUnion"
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v6/*: any*/),
                    (v57/*: any*/)
                  ],
                  "type": "Section",
                  "abstractKey": null
                },
                (v20/*: any*/),
                (v21/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v4/*: any*/),
                    (v33/*: any*/),
                    (v5/*: any*/),
                    (v34/*: any*/),
                    (v36/*: any*/),
                    (v38/*: any*/),
                    (v53/*: any*/),
                    (v54/*: any*/)
                  ],
                  "type": "BaseWithApplicationAndUrlAlias",
                  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FormattedValue",
          "kind": "LinkedField",
          "name": "subHeadline",
          "plural": false,
          "selections": (v62/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FormattedValue",
          "kind": "LinkedField",
          "name": "summary",
          "plural": false,
          "selections": [
            (v61/*: any*/),
            (v23/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "shortUrl",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v33/*: any*/),
            (v34/*: any*/),
            (v36/*: any*/),
            (v38/*: any*/),
            (v53/*: any*/),
            (v45/*: any*/)
          ],
          "type": "BaseWithApplicationAndUrlAlias",
          "abstractKey": "__isBaseWithApplicationAndUrlAlias"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v43/*: any*/),
            (v28/*: any*/),
            (v29/*: any*/),
            (v63/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Article",
              "kind": "LinkedField",
              "name": "seriesContainer",
              "plural": false,
              "selections": [
                (v63/*: any*/),
                (v10/*: any*/),
                (v55/*: any*/)
              ],
              "storageKey": null
            },
            (v30/*: any*/),
            (v27/*: any*/),
            (v64/*: any*/),
            (v65/*: any*/),
            (v66/*: any*/),
            (v32/*: any*/),
            (v57/*: any*/),
            (v47/*: any*/)
          ],
          "type": "Article",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "youtubeId",
              "storageKey": null
            },
            (v49/*: any*/),
            (v50/*: any*/)
          ],
          "type": "Video",
          "abstractKey": null
        }
      ],
      "type": "Content",
      "abstractKey": "__isContent"
    }
  ],
  "type": "Article",
  "abstractKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": [
    (v8/*: any*/),
    (v14/*: any*/),
    (v7/*: any*/),
    {
      "alias": "size768x768",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "style": "768x768"
          }
        }
      ],
      "concreteType": "ImageStyle",
      "kind": "LinkedField",
      "name": "style",
      "plural": false,
      "selections": (v9/*: any*/),
      "storageKey": "style(filter:{\"style\":\"768x768\"})"
    },
    (v15/*: any*/)
  ],
  "storageKey": null
},
v69 = {
  "kind": "InlineFragment",
  "selections": [
    (v33/*: any*/),
    (v5/*: any*/),
    (v34/*: any*/),
    (v36/*: any*/),
    (v38/*: any*/),
    (v53/*: any*/),
    (v45/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v70 = {
  "kind": "InlineFragment",
  "selections": [
    (v27/*: any*/),
    (v64/*: any*/),
    (v65/*: any*/),
    (v66/*: any*/),
    (v32/*: any*/),
    (v30/*: any*/),
    (v47/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "hooksTopicWidgetLazyLoadQuery",
    "selections": [
      {
        "condition": "isShowPostMagazineDiscoveryWidget",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "discoveryWidgetPostMagazineQueueQuery"
          }
        ]
      },
      {
        "condition": "isShowChinaScienceDiscoveryWidget",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "chinaScienceDiscoveryWidgetQuery"
          }
        ]
      },
      {
        "condition": "isShowHundredTopTablesDiscoveryWidget",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "hundredTopTablesDiscoveryWidgetQuery"
          }
        ]
      },
      {
        "condition": "isShowOpenQuestionsSeriesDiscoveryWidget",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "scmpPlusPaywallTypeIds",
                "variableName": "scmpPlusPaywallTypeIds"
              }
            ],
            "kind": "FragmentSpread",
            "name": "openQuestionsSeriesDiscoveryWidgetQuery"
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "hooksTopicWidgetLazyLoadQuery",
    "selections": [
      {
        "condition": "isShowPostMagazineDiscoveryWidget",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "postMagazineLast7Days",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "name": "scmp_trending_section_scmp_trending_section_postmag_last_7_days"
                }
              }
            ],
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QueueItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v4/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v5/*: any*/),
                                  (v12/*: any*/),
                                  (v13/*: any*/),
                                  (v16/*: any*/),
                                  (v17/*: any*/),
                                  (v18/*: any*/),
                                  (v22/*: any*/),
                                  (v25/*: any*/),
                                  (v26/*: any*/),
                                  (v48/*: any*/),
                                  (v46/*: any*/),
                                  (v51/*: any*/)
                                ],
                                "type": "Content",
                                "abstractKey": "__isContent"
                              }
                            ],
                            "type": "Article",
                            "abstractKey": null
                          },
                          (v21/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "items(first:6)"
              },
              (v10/*: any*/)
            ],
            "storageKey": "queue(filter:{\"name\":\"scmp_trending_section_scmp_trending_section_postmag_last_7_days\"})"
          },
          {
            "alias": "postMagazineSponsor",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "name": "discovery_module_discovery_module_71"
                }
              }
            ],
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v52/*: any*/),
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QueueItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v4/*: any*/),
                                  (v5/*: any*/),
                                  (v12/*: any*/),
                                  (v13/*: any*/),
                                  (v16/*: any*/),
                                  (v17/*: any*/),
                                  (v18/*: any*/),
                                  (v22/*: any*/),
                                  (v25/*: any*/),
                                  (v26/*: any*/),
                                  (v48/*: any*/),
                                  (v46/*: any*/),
                                  (v51/*: any*/)
                                ],
                                "type": "Content",
                                "abstractKey": "__isContent"
                              }
                            ],
                            "type": "Article",
                            "abstractKey": null
                          },
                          (v21/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "items(first:1)"
              },
              (v10/*: any*/)
            ],
            "storageKey": "queue(filter:{\"name\":\"discovery_module_discovery_module_71\"})"
          },
          {
            "alias": "postMagazineSection",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "entityId": "71"
                }
              }
            ],
            "concreteType": "Section",
            "kind": "LinkedField",
            "name": "section",
            "plural": false,
            "selections": (v56/*: any*/),
            "storageKey": "section(filter:{\"entityId\":\"71\"})"
          }
        ]
      },
      {
        "condition": "isShowChinaScienceDiscoveryWidget",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "chinaScienceSection",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "entityId": "328475"
                }
              }
            ],
            "concreteType": "Section",
            "kind": "LinkedField",
            "name": "section",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v4/*: any*/),
              (v37/*: any*/),
              (v10/*: any*/)
            ],
            "storageKey": "section(filter:{\"entityId\":\"328475\"})"
          },
          {
            "alias": "chinaScienceQueue",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "name": "section_top_328475"
                }
              }
            ],
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QueueItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v67/*: any*/),
                          (v21/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "items(first:6)"
              },
              (v10/*: any*/)
            ],
            "storageKey": "queue(filter:{\"name\":\"section_top_328475\"})"
          }
        ]
      },
      {
        "condition": "isShowHundredTopTablesDiscoveryWidget",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "hundredTopTablesLast7Days",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "name": "scmp_trending_section_scmp_trending_section_100_top_tables_last_7_days"
                }
              }
            ],
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 5
                  }
                ],
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QueueItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v4/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v58/*: any*/),
                                  (v59/*: any*/),
                                  (v60/*: any*/),
                                  (v26/*: any*/),
                                  (v13/*: any*/),
                                  (v68/*: any*/),
                                  (v17/*: any*/),
                                  (v18/*: any*/),
                                  (v22/*: any*/),
                                  (v12/*: any*/),
                                  (v69/*: any*/),
                                  (v70/*: any*/)
                                ],
                                "type": "Content",
                                "abstractKey": "__isContent"
                              }
                            ],
                            "type": "Article",
                            "abstractKey": null
                          },
                          (v21/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "items(first:5)"
              },
              (v10/*: any*/)
            ],
            "storageKey": "queue(filter:{\"name\":\"scmp_trending_section_scmp_trending_section_100_top_tables_last_7_days\"})"
          },
          {
            "alias": "hundredTopTablesSponsor",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "name": "discovery_module_discovery_module_517759"
                }
              }
            ],
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v52/*: any*/),
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QueueItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v4/*: any*/),
                                  (v58/*: any*/),
                                  (v59/*: any*/),
                                  (v60/*: any*/),
                                  (v26/*: any*/),
                                  (v13/*: any*/),
                                  (v68/*: any*/),
                                  (v17/*: any*/),
                                  (v18/*: any*/),
                                  (v22/*: any*/),
                                  (v12/*: any*/),
                                  (v69/*: any*/),
                                  (v70/*: any*/)
                                ],
                                "type": "Content",
                                "abstractKey": "__isContent"
                              }
                            ],
                            "type": "Article",
                            "abstractKey": null
                          },
                          (v21/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "items(first:1)"
              },
              (v10/*: any*/)
            ],
            "storageKey": "queue(filter:{\"name\":\"discovery_module_discovery_module_517759\"})"
          },
          {
            "alias": "hundredTopTablesSection",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "entityId": "517759"
                }
              }
            ],
            "concreteType": "Section",
            "kind": "LinkedField",
            "name": "section",
            "plural": false,
            "selections": (v56/*: any*/),
            "storageKey": "section(filter:{\"entityId\":\"517759\"})"
          }
        ]
      },
      {
        "condition": "isShowOpenQuestionsSeriesDiscoveryWidget",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "openQuestionSeriesTopic",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "entityId": "518656"
                }
              }
            ],
            "concreteType": "Topic",
            "kind": "LinkedField",
            "name": "topic",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": [
                  {
                    "fields": [
                      {
                        "kind": "Variable",
                        "name": "paywallTypeIds",
                        "variableName": "scmpPlusPaywallTypeIds"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "exclude"
                  },
                  (v1/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "orderBy",
                    "value": {
                      "direction": "DESC",
                      "field": "PUBLISHED_DATE"
                    }
                  }
                ],
                "concreteType": "ContentConnection",
                "kind": "LinkedField",
                "name": "contents",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v10/*: any*/),
                          (v67/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v10/*: any*/)
            ],
            "storageKey": "topic(filter:{\"entityId\":\"518656\"})"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "32f96036f8d4798589c80e828209d988",
    "id": null,
    "metadata": {},
    "name": "hooksTopicWidgetLazyLoadQuery",
    "operationKind": "query",
    "text": "query hooksTopicWidgetLazyLoadQuery(\n  $isShowChinaScienceDiscoveryWidget: Boolean!\n  $isShowHundredTopTablesDiscoveryWidget: Boolean!\n  $isShowOpenQuestionsSeriesDiscoveryWidget: Boolean!\n  $isShowPostMagazineDiscoveryWidget: Boolean!\n  $scmpPlusPaywallTypeIds: [String!]\n) {\n  ...discoveryWidgetPostMagazineQueueQuery @include(if: $isShowPostMagazineDiscoveryWidget)\n  ...chinaScienceDiscoveryWidgetQuery @include(if: $isShowChinaScienceDiscoveryWidget)\n  ...hundredTopTablesDiscoveryWidgetQuery @include(if: $isShowHundredTopTablesDiscoveryWidget)\n  ...openQuestionsSeriesDiscoveryWidgetQuery_2uEaAo @include(if: $isShowOpenQuestionsSeriesDiscoveryWidget)\n}\n\nfragment articleCommentArticle on Article {\n  ...entityLink\n  commentCount\n  entityId\n}\n\nfragment blockquoteQuoteContent on Content {\n  __isContent: __typename\n  ...contentShareWidgetContent\n}\n\nfragment checkersCheckContentContainsStarlingImageContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment chinaScienceDiscoveryWidgetQuery on Query {\n  chinaScienceSection: section(filter: {entityId: \"328475\"}) {\n    ...latestDiscoveryWidgetSection\n    id\n  }\n  chinaScienceQueue: queue(filter: {name: \"section_top_328475\"}) {\n    ...latestDiscoveryWidgetQueue\n    id\n  }\n}\n\nfragment contentActionBarContent on Content {\n  __isContent: __typename\n  entityId\n  createdDate\n  updatedDate\n  publishedDate\n  readingTime\n  ...articleCommentArticle\n  ...helpersIsArticleVideoAsHeroArticle\n  ...helpersGetContentTypeNameContent\n  ... on Article {\n    hasVideoContent\n  }\n}\n\nfragment contentCoverImageContent_2g6DLq on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size768x768: style(filter: {style: \"768x768\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_2ihLSb on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size1200x800: style(filter: {style: \"1200x800\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentHeadlineContent on Content {\n  __isContent: __typename\n  headline\n  socialHeadline\n  ...contentHeadlineTagContent\n  ...helpersUseContentSponsorContent\n}\n\nfragment contentHeadlineTagContent on Content {\n  __isContent: __typename\n  ...hooksContentHeadlineTagContent\n}\n\nfragment contentLiveTagContent on Article {\n  ...helpersCheckHasLiveTagArticle\n}\n\nfragment contentNewsletterWidgetContent on Content {\n  __isContent: __typename\n  topics {\n    relatedNewsletters {\n      ...helpersMassageToNewsletterItemNewsletter\n      id\n    }\n    id\n  }\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        relatedNewsletters {\n          ...helpersMassageToNewsletterItemNewsletter\n          id\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  ... on Article {\n    relatedNewsletters {\n      ...helpersMassageToNewsletterItemNewsletter\n      id\n    }\n  }\n}\n\nfragment contentReadingTimeContent on Content {\n  __isContent: __typename\n  readingTime\n  flag\n}\n\nfragment contentSchemaRenderContent on Content {\n  __isContent: __typename\n  ...blockquoteQuoteContent\n  ...hooksInlinePlusWidgetContent\n  ...imageContent\n  ...inlineWidgetContent\n  ...photoGalleryWidgetContent\n  ...scmpYoutubeContent\n}\n\nfragment contentSectionsContent on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on VideoSection {\n        name\n      }\n      ...helpersCheckIfNewsSectionInFirstIndexSection\n      ...entityLink\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment contentSeriesShortLabelContent on Content {\n  __isContent: __typename\n  ... on Article {\n    seriesShortLabel\n    ...entityLink\n    seriesContainer {\n      ...entityLink\n      seriesShortLabel\n      id\n    }\n  }\n}\n\nfragment contentShareWidgetContent on Content {\n  __isContent: __typename\n  __typename\n  entityId\n  urlAlias\n  shortUrl\n  socialHeadline\n  headline\n  ... on Video {\n    youtubeId\n  }\n}\n\nfragment contentSponsorTagContent on Content {\n  __isContent: __typename\n  ...helpersUseContentSponsorContent\n}\n\nfragment contentSubHeadlineContent on Content {\n  __isContent: __typename\n  subHeadline {\n    json\n  }\n  summary {\n    json\n  }\n  ...contentSchemaRenderContent\n}\n\nfragment contentSummaryContent on Content {\n  __isContent: __typename\n  __typename\n  summary {\n    text\n  }\n}\n\nfragment contentTopicLinkContent on Content {\n  __isContent: __typename\n  topics {\n    urlAlias\n    ...entityLink\n    ...topicLinkTopic\n    id\n  }\n}\n\nfragment discoveryWidgetPostMagazineQueueQuery on Query {\n  postMagazineLast7Days: queue(filter: {name: \"scmp_trending_section_scmp_trending_section_postmag_last_7_days\"}) {\n    items(first: 6) {\n      edges {\n        node {\n          __typename\n          ... on Article {\n            entityId\n            ...postMagazineDiscoveryItemContent\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  postMagazineSponsor: queue(filter: {name: \"discovery_module_discovery_module_71\"}) {\n    items(first: 1) {\n      edges {\n        node {\n          __typename\n          ... on Article {\n            ...postMagazineDiscoveryItemContent\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  postMagazineSection: section(filter: {entityId: \"71\"}) {\n    ...entityLink\n    id\n  }\n}\n\nfragment entityLink on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  entityId\n  entityUuid\n  urlAlias\n  urlRedirect {\n    toUrl\n    id\n  }\n  application {\n    entityId\n    id\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      id\n    }\n    parentSection\n  }\n  ...helpersAppBarVariantBase\n  ...helpersApplicationBase\n  ...helpersCheckIsPlusArticle\n  ...helpersStyleSectionContent\n}\n\nfragment helpersAppBarVariantBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsLiveArticle\n  ...helpersCheckIsPlusPage\n  ...helpersCheckIsPostMagazineArticle\n  ...helpersCheckIsStyleArticle\n  ...helpersSectionContent\n  ...helpersStyleSectionContent\n}\n\nfragment helpersApplicationBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsPlusPage\n}\n\nfragment helpersCheckHasLiveTagArticle on Article {\n  flattenTypeIds\n  liveArticle {\n    status\n    id\n  }\n}\n\nfragment helpersCheckHasSeriesShortLabelContent on Content {\n  __isContent: __typename\n  ... on Article {\n    seriesShortLabel\n    seriesContainer {\n      seriesShortLabel\n      id\n    }\n  }\n}\n\nfragment helpersCheckIfNewsSectionInFirstIndexSection on SectionUnion {\n  __isSectionUnion: __typename\n  ... on Section {\n    name\n  }\n  ... on VideoSection {\n    name\n  }\n}\n\nfragment helpersCheckIsLiveArticle on Article {\n  flattenTypeIds\n  liveArticle {\n    status\n    id\n  }\n}\n\nfragment helpersCheckIsMainTopicContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment helpersCheckIsPlusArticle on Content {\n  __isContent: __typename\n  ... on Article {\n    paywallTypes {\n      entityUuid\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsPlusPage on Page {\n  urlAlias\n}\n\nfragment helpersCheckIsPostMagazineArticle on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersCheckIsStyleArticle on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersGetArticleTypeNameArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersGetContentTypeNameContent on Content {\n  __isContent: __typename\n  __typename\n  ... on Article {\n    ...helpersGetArticleTypeNameArticle\n  }\n}\n\nfragment helpersIsArticleVideoAsHeroArticle on Article {\n  multimediaEmbed {\n    json\n  }\n}\n\nfragment helpersMassageToNewsletterItemNewsletter on Newsletter {\n  entityId\n  name\n  alternativeName\n  description {\n    text\n  }\n  summary {\n    text\n  }\n  homepageDescription {\n    text\n  }\n}\n\nfragment helpersSanitizeArticleTypeEntityIdsArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersSanitizeAuthorTypesArticle on Article {\n  authors {\n    types\n    id\n  }\n}\n\nfragment helpersSanitizedAuthorEntityIdsArticle on Article {\n  authors {\n    entityId\n    id\n  }\n}\n\nfragment helpersSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersStyleSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersUseContentSponsorContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    sponsor {\n      ...sponsorTagSponsor\n      name\n      type\n      id\n    }\n    id\n  }\n  ... on Article {\n    sponsorType\n  }\n  ...helpersCheckIsMainTopicContent\n}\n\nfragment homeSecondaryContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...helpersCheckIsPlusArticle\n  ...helpersCheckHasLiveTagArticle\n  ...helpersCheckHasSeriesShortLabelContent\n  ...helpersUseContentSponsorContent\n  ...hooksContentItemProvidersContent_1uhIyn\n}\n\nfragment hooksContentHeadlineTagContent on Content {\n  __isContent: __typename\n  __typename\n  ... on Article {\n    types {\n      value {\n        name\n        entityId\n        description {\n          text\n        }\n        id\n      }\n    }\n    ...helpersCheckIsStyleArticle\n  }\n  flag\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on VideoSection {\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  ...hooksContentHelperContent\n}\n\nfragment hooksContentHelperContent on Content {\n  __isContent: __typename\n  ...helpersSanitizeArticleTypeEntityIdsArticle\n  ...helpersSanitizeAuthorTypesArticle\n  ...helpersSanitizedAuthorEntityIdsArticle\n  flag\n}\n\nfragment hooksContentItemProvidersContent_14w7Xi on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_2ihLSb\n  ...contentHeadlineContent\n  ...contentSummaryContent\n  ...contentReadingTimeContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_1uhIyn on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentCoverImageContent_2ihLSb\n  ...contentHeadlineContent\n  ...contentLiveTagContent\n  ...contentSectionsContent\n  ...contentSubHeadlineContent\n  ...contentSummaryContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ...contentSeriesShortLabelContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_Y5tau on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentCoverImageContent_2g6DLq\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksInlinePlusWidgetContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment hundredTopTablesContent on Content {\n  __isContent: __typename\n  ...entityLink\n  ...hooksContentItemProvidersContent_Y5tau\n}\n\nfragment hundredTopTablesDiscoveryWidgetQuery on Query {\n  hundredTopTablesLast7Days: queue(filter: {name: \"scmp_trending_section_scmp_trending_section_100_top_tables_last_7_days\"}) {\n    items(first: 5) {\n      edges {\n        node {\n          __typename\n          ... on Article {\n            entityId\n            ...hundredTopTablesContent\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  hundredTopTablesSponsor: queue(filter: {name: \"discovery_module_discovery_module_517759\"}) {\n    items(first: 1) {\n      edges {\n        node {\n          __typename\n          ... on Article {\n            ...hundredTopTablesContent\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  hundredTopTablesSection: section(filter: {entityId: \"517759\"}) {\n    ...entityLink\n    id\n  }\n}\n\nfragment imageContent on Content {\n  __isContent: __typename\n  headline\n  ...checkersCheckContentContainsStarlingImageContent\n}\n\nfragment inlineWidgetContent on Content {\n  __isContent: __typename\n  ...contentNewsletterWidgetContent\n}\n\nfragment latestDiscoveryWidgetQueue on Queue {\n  items(first: 6) {\n    edges {\n      node {\n        __typename\n        ... on Article {\n          entityId\n          ...homeSecondaryContentItemContent\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment latestDiscoveryWidgetSection on Section {\n  urlAlias\n  name\n  entityId\n  parentSection\n}\n\nfragment openQuestionsSeriesDiscoveryWidgetQuery_2uEaAo on Query {\n  openQuestionSeriesTopic: topic(filter: {entityId: \"518656\"}) {\n    name\n    urlAlias\n    contents(exclude: {paywallTypeIds: $scmpPlusPaywallTypeIds}, first: 6, orderBy: {field: PUBLISHED_DATE, direction: DESC}) {\n      edges {\n        node {\n          __typename\n          ... on Article {\n            entityId\n            ...homeSecondaryContentItemContent\n          }\n          id\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment photoGalleryDialogContent on Content {\n  __isContent: __typename\n  __typename\n  ...contentShareWidgetContent\n}\n\nfragment photoGalleryWidgetContent on Content {\n  __isContent: __typename\n  ...photoGalleryDialogContent\n}\n\nfragment postMagazineDiscoveryItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...articleCommentArticle\n  ...entityLink\n  ...helpersCheckHasLiveTagArticle\n  ...helpersUseContentSponsorContent\n  ...hooksContentItemProvidersContent_14w7Xi\n}\n\nfragment scmpYoutubeContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  publishedDate\n}\n\nfragment sponsorTagSponsor on Sponsor {\n  name\n  type\n  images {\n    url\n  }\n}\n\nfragment topicLinkTopic on Topic {\n  ...entityLink\n  name\n  shortName\n}\n\nfragment videoDurationOverlayVideo on Video {\n  duration\n  sectionsV2 {\n    value {\n      __typename\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "39bf3ae2518a58d4d1bd9ae6cd637b98";

export default node;
